module.exports = __webpack_public_path__ + "images/content-kitchen.35fc86b312d4dbf245457bb01a48fda1.svg";